import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faDesktop, faMobileAlt, faTabletAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false

// Font Awesome
library.add(faDesktop)
library.add(faMobileAlt)
library.add(faTabletAlt)
Vue.component('font-awesome-icon', FontAwesomeIcon)

// The styles
import '@/assets/css/app.scss'

// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

// axios
import axios from 'axios'
Vue.prototype.axios = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
